import { IconProps } from '@/components/Icon';

export const IconCalendar = ({ width = 16, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 16 16' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M4 1.75a.75.75 0 0 1 1.5 0V3h5V1.75a.75.75 0 0 1 1.5 0V3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2V1.75ZM4.5 6a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-7Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
};
